export default "__VITE_ASSET__e77e24f1__"